import Banner from "../components/Banner";
import Seated from "../components/Seated";
import { useEffect, useRef } from "react";
import { isMobile } from 'react-device-detect';

const scrollToRef = (ref) => window.scrollTo({
  top: ref.current.offsetTop,
  left: 0,
  behavior: 'smooth'
})

export default function Tour() {

  const myRef = useRef(null)
  useEffect(() => {
    const timer = setTimeout(() => scrollToRef(myRef), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Banner page="tour" />
      <div className="scroll-container" ref={isMobile ? null : myRef}>
        <Seated />
      </div>
    </div>
  );
}